module.exports = require("./nyn");